import Axios from '../Axios';

export interface GuestCountryResponse {
  success: boolean;
  countryCode: string | null;
  country: string | null;
  ip?: string;
  message?: string;
}

export const getGuestCountry = async (): Promise<GuestCountryResponse> => {
  const response = await Axios.get<GuestCountryResponse>(
    '/api/geo-location/country',
  );

  return response.data;
};